










































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import FormRow from '@/components/common/forms/FormRow.vue';
import FormInput from '@/components/common/forms/FormInput.vue';
import FormError from '@/components/common/forms/FormError.vue';
import { AgencyModel } from 'admiral-core';
import FormTextarea from '@/components/common/forms/FormTextarea.vue';
import { CheckIcon, CopyIcon, PlusIcon } from 'vue-feather-icons';
import FormDateInput from '@/components/common/forms/FormDateInput.vue';
import AgencyStatusSelect from '@/components/common/selects/AgencyStatusSelect.vue';
import { Util } from '@/utils/Util';
import AgencyPlanSelect from '@/components/common/selects/AgencyPlanSelect.vue';
import AgencyTypeSelect from '@/components/common/selects/AgencyTypeSelect.vue';
import AdmiralCheckbox from '@/components/common/selects/AdmiralCheckbox.vue';

@Component({
  components: {
    AdmiralCheckbox,
    AgencyTypeSelect,
    AgencyPlanSelect,
    AgencyStatusSelect,
    FormDateInput,
    FormTextarea,
    FormError,
    FormInput,
    FormRow,
    PlusIcon,
    CopyIcon,
    CheckIcon,
  },
})
export default class AgencyForm extends Vue {
  @Prop({ required: true, type: Object })
  readonly value!: AgencyModel;

  @Prop({ required: true, type: Object })
  readonly errors!: AgencyModel;

  copied = false;

  async mounted() {
    //
  }

  get planJsonStr() {
    return JSON.stringify(this.value.plan, null, 2);
  }

  onInput(key: string, value: any) {
    const obj = { ...this.value, [key]: value };

    if (key === 'startedAt') {
      obj.endsAt = Util.formatAgencyStatusEndsAt(value, this.value.status!);
    } else if (key === 'status') {
      obj.endsAt = Util.formatAgencyStatusEndsAt(value.startedAt, value);
    }
    this.$emit('input', obj);
  }

  onErrorReset(key: string) {
    this.$emit('reset-error', key);
  }

  get url() {
    return `https://${this.value.identifier}.app.admiral-dashboard.de`;
  }

  async handleCopyToClipboard() {
    // navigator.clipboard.writeText(this.url);

    const tmpTextField = document.createElement('textarea');
    tmpTextField.textContent = this.url;
    tmpTextField.setAttribute('style', 'position:absolute; right:200%;');
    document.body.appendChild(tmpTextField);
    tmpTextField.select();
    tmpTextField.setSelectionRange(0, 99999); /*For mobile devices*/
    document.execCommand('copy');
    tmpTextField.remove();

    this.copied = true;
  }
}
